export { InlineSVGConfig, SVGScriptEvalMode } from './inline-svg.config';
export { InlineSVGDirective } from './inline-svg.directive';
export { InlineSVGModule } from './inline-svg.module';
export { SVGCacheService } from './svg-cache.service';
